// src/components/ui/SuccessNotification.js
import React, { useEffect } from 'react';
import { Check } from 'lucide-react';

export default function SuccessNotification({ message, onClose }) {
    useEffect(() => {
        const timer = setTimeout(() => onClose(), 5000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className="fixed top-24 right-6 z-50 animate-slide-in">
            <div className="bg-white border-2 border-[var(--jade-green)] rounded-xl shadow-2xl px-6 py-4 flex items-center gap-3 max-w-md">
                <div className="w-10 h-10 rounded-full bg-[var(--jade-green)] flex items-center justify-center flex-shrink-0">
                    <Check className="w-6 h-6 text-white" />
                </div>
                <p className="text-[var(--charcoal-black)] font-medium">{message}</p>
            </div>
        </div>
    );
}